module.exports = __webpack_public_path__ + "static/TownOfLight2-3eb46853cff9e7c449d1359c3083f1e0.webp";